import {
  blue25,
  blue55,
  blue75,
  blue100,
  blue135,
  blue155,
  blue180,
  blueVioletDesat35,
  brownYellow25,
  brownYellow180,
  fluorescentBlueViolet69,
  fluorescentCyan185,
  fluorescentPink119,
  greenBlue100,
  greenBlue135,
  greenBlue180,
  greenBlueDesat155,
  greenDesat100,
  orange100,
  orange135,
  orange155,
  pink115,
  pink135,
  violet155,
  violetPinkDesat100,
  yellow135,
  yellowGreen100,
  yellowGreen135,
} from '@spotify-internal/encore-foundation';

export type ChartColorType =
  | 'pink'
  | 'flourescent'
  | 'yellowGreen'
  | 'brownYellow'
  | 'violet'
  | 'greenBlue'
  | 'blue'
  | 'orange'
  | 'greenBlueDesat';

const chartColors: {
  light: Record<ChartColorType, string>;
  dark: Record<ChartColorType, string>;
} = {
  light: {
    pink: fluorescentPink119,
    flourescent: fluorescentBlueViolet69,
    yellowGreen: yellowGreen100,
    brownYellow: brownYellow25,
    violet: violetPinkDesat100,
    greenBlue: greenBlue100,
    blue: blue100,
    orange: orange100,
    greenBlueDesat: blueVioletDesat35,
  },
  dark: {
    pink: pink115,
    flourescent: fluorescentCyan185,
    yellowGreen: yellowGreen135,
    brownYellow: brownYellow180,
    violet: violet155,
    greenBlue: greenBlue100,
    blue: blue100,
    orange: orange135,
    greenBlueDesat: greenBlueDesat155,
  },
};

export const getChartColors = (mode: 'light' | 'dark') => {
  return mode === 'light' ? chartColors.light : chartColors.dark;
};

export const defaultChartColors: ChartColorType[] = [
  'pink',
  'flourescent',
  'yellowGreen',
  'violet',
  'blue',
  'greenBlue',
  'orange',
  'greenBlueDesat',
  'brownYellow',
];

const confidenceSequentialColors: Record<'light' | 'dark', readonly string[]> =
  {
    light: [blue100, blue75, blue55, blue25],
    dark: [blue100, blue135, blue155, blue180],
  };

const confidenceCategoricalColors: Record<'light' | 'dark', readonly string[]> =
  {
    light: [
      blue100,
      greenBlue135,
      yellow135,
      violetPinkDesat100,
      orange135,
      blue55,
      pink135,
      greenDesat100,
    ],
    dark: [
      blue100,
      greenBlue180,
      brownYellow180,
      violet155,
      orange155,
      blue155,
      pink135,
      greenDesat100,
    ],
  };

export const getConfidenceSequentialColors = (
  mode: 'light' | 'dark',
): readonly string[] => confidenceSequentialColors[mode];

export const getConfidenceCategoricalColors = (
  mode: 'light' | 'dark',
): readonly string[] => confidenceCategoricalColors[mode];

export const getConfidencePrimaryChartColor = (
  mode: 'light' | 'dark',
): string => confidenceSequentialColors[mode][0];
